import React from 'react';

export default function Select({ className = '', children, ...props }) {
  const cls = ['select'];
  if (className) cls.push(className);
  return (
    <select className={cls.join(' ')} {...props}>
      {children}
    </select>
  );
}
